/* ============================================================
   D&V Market — Formulario EasySell con la estructura del de Saluha
   (index.html:304-427 de Saluha). Cuando EasySell abre su formulario:
   - Banner "Llena tus datos y elige la mejor oferta para ti" arriba.
   - Tarjeta CONTACTO: Nombre | Apellido, Teléfono (WhatsApp).
   - Tarjeta DIRECCIÓN DE ENTREGA: Dirección, Departamento | Municipio,
     Zona/Referencia y el aviso "8 de cada 10 pedidos…".
   - Tarjetas MÉTODO DE ENVÍO (Envío gratis) y MÉTODO DE PAGO (contra entrega).
   - Botón de compra y, debajo, sello de garantía + tiempos de entrega.
   Solo mueve los grupos de campos de EasySell (no los recrea), así que
   sus validaciones y el envío del pedido siguen funcionando igual.
   ============================================================ */
(function () {
  'use strict';

  var ASSETS = (window.DV_ASSETS || {});
  var ICO = {
    user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"/>',
    pin: '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>',
    home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/>',
    map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/>',
    building: '<rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01"/>',
    check: '<path d="M20 6 9 17l-5-5"/>'
  };
  function svg(n, extra) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"' + (extra || '') + '>' + ICO[n] + '</svg>';
  }

  // Campos: [grupo, placeholder, ícono, ancho medio]
  var CAMPOS = {
    first_name: ['Nombre', 'user', true],
    last_name: ['Apellido', 'user', true],
    phone: ['Teléfono (WhatsApp)', 'phone', false],
    address: ['Ej: 6a Av. 10-25, Zona 1', 'pin', false],
    province: [null, 'map', false],
    city: [null, 'building', false],
    address2: ['Zona / Colonia / Referencia', 'home', false]
  };

  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function grupo(form, k) { return form.querySelector('.es-' + k + '-group'); }

  function prepararCampo(g, k) {
    var c = CAMPOS[k]; if (!g || !c) return;
    g.classList.add('dv-campo');
    if (c[2]) g.classList.add('dv-campo--mitad');
    var input = g.querySelector('input, select, textarea');
    if (input && c[0] && input.tagName !== 'SELECT') input.setAttribute('placeholder', c[0]);
    if (input) {
      var lab = g.querySelector('.es-label');
      if (lab) input.setAttribute('aria-label', lab.textContent.replace('*', '').trim());
    }
    if (!g.querySelector('.dv-campo__ico')) {
      var ico = el('<span class="dv-campo__ico">' + svg(c[1]) + '</span>');
      var cont = g.querySelector('.es-input-container') || g;
      cont.style.position = 'relative';
      cont.insertBefore(ico, cont.firstChild);
    }
  }

  function armar(form) {
    if (!form || form.dataset.dvArmado === '1') return;
    var contacto = ['first_name', 'last_name', 'phone'].map(function (k) { return grupo(form, k); });
    var direccion = ['address', 'province', 'city', 'address2'].map(function (k) { return grupo(form, k); });
    var cta = form.querySelector('.es-cta-group');
    if (!cta || !contacto[0] || !direccion[0]) return; // EasySell aún no termina de armar el formulario
    form.dataset.dvArmado = '1';
    form.classList.add('dv-form');

    // Banner arriba (después del encabezado de EasySell)
    var head = form.querySelector('.es-form-header');
    if (ASSETS.header && head && !form.querySelector('.dv-form-banner')) {
      head.insertAdjacentElement('afterend', el('<div class="dv-form-banner"><img src="' + ASSETS.header + '" alt="Llena tus datos y elige la mejor oferta para ti" width="1040" height="416"></div>'));
    }

    // Tarjeta CONTACTO
    var secC = el('<section class="dv-fsec"><h4 class="dv-fsec__title">Contacto</h4><div class="dv-fsec__grid"></div></section>');
    // Tarjeta DIRECCIÓN DE ENTREGA
    var secD = el('<section class="dv-fsec"><h4 class="dv-fsec__title">Dirección de entrega</h4><div class="dv-fsec__grid"></div></section>');
    var primero = contacto.filter(Boolean)[0];
    primero.parentNode.insertBefore(secC, primero);
    secC.insertAdjacentElement('afterend', secD);
    ['first_name', 'last_name', 'phone'].forEach(function (k, i) { if (contacto[i]) { prepararCampo(contacto[i], k); secC.lastChild.appendChild(contacto[i]); } });
    ['address', 'province', 'city', 'address2'].forEach(function (k, i) { if (direccion[i]) { prepararCampo(direccion[i], k); secD.lastChild.appendChild(direccion[i]); } });
    secD.appendChild(el('<div class="dv-formwarn"><span class="dv-formwarn__ico">' + svg('pin') + '</span><span><b>8 de cada 10 pedidos con la dirección mal escrita se devuelven.</b> Escribe la tuya completa, con zona y un punto de referencia: color de la casa, tienda o iglesia cercana.</span></div>'));

    // Tarjetas de envío y pago (informativas: siempre envío gratis y pago contra entrega)
    secD.insertAdjacentElement('afterend', el(
      '<section class="dv-fsec"><h4 class="dv-fsec__title">Método de envío</h4>' +
      '<div class="dv-mcard is-sel"><span class="dv-mcard__dot"></span><span class="dv-mcard__main"><b>Envío gratis</b><small>Se proporciona número de guía</small></span><span class="dv-mcard__free">GRATIS</span></div></section>'));
    secD.nextElementSibling.insertAdjacentElement('afterend', el(
      '<section class="dv-fsec"><h4 class="dv-fsec__title">Método de pago</h4>' +
      '<div class="dv-mcard is-sel"><span class="dv-mcard__dot"></span><span class="dv-mcard__main"><b>Pago contra entrega</b><small>Pagas en efectivo al recibir tu pedido</small></span></div></section>'));

    // Debajo del botón: garantía y tiempos
    if (!form.querySelector('.dv-garantia')) {
      cta.insertAdjacentElement('afterend', el(
        '<div class="dv-garantia">' +
        (ASSETS.garantia ? '<img src="' + ASSETS.garantia + '" alt="100% garantía en nuestros productos" width="1040" height="416" loading="lazy">' : '') +
        '<p class="dv-garantia__dias">¡Recíbelo en 1 a 5 días hábiles!</p>' +
        '<p class="dv-garantia__nota">Pagas en efectivo al recibir. Sin anticipos.</p></div>'));
    }
    var btn = cta.querySelector('.es-cta-btn');
    if (btn && !btn.querySelector('.dv-btn-sub')) {
      btn.appendChild(el('<span class="dv-btn-sub">' + svg('check') + ' Sin cobros ocultos</span>'));
      btn.appendChild(el('<span class="dv-btn-shine" aria-hidden="true"></span>'));
    }
  }

  // La primera opción de las listas va corta, como en Saluha ("Departamento", "Municipio").
  // EasySell la vuelve a crear al cambiar de departamento, por eso se revisa siempre.
  function rotularListas() {
    [['es-province', 'Departamento'], ['es-city', 'Municipio']].forEach(function (par) {
      var s = document.getElementById(par[0]);
      if (s && s.options.length && !s.options[0].value && s.options[0].text !== par[1]) s.options[0].text = par[1];
    });
  }

  function revisar() {
    var form = document.querySelector('#easysell #es-form');
    if (form) { armar(form); rotularListas(); }
  }
  new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true });
  revisar();
})();
